














import Vue from 'vue';
import {Component, Watch} from 'vue-property-decorator';
import Layout from '@/components/Layout.vue';
import Icon from '@/components/Icon.vue';
import Calculator from '@/components/Money/Calculator.vue';
import TagList from '@/components/Money/TagList.vue';
import clone from '@/lib/clone';
import {defaultIncomeTags} from '@/constants/defaultTags';
import TabBar from '@/components/TabBar.vue';

@Component({
    components: {TabBar, TagList, Calculator, Icon, Layout}
})
export default class Money extends Vue {

    record: RecordItem = this.initRecord();
    incomeTags = defaultIncomeTags;

    get tagList(): TagItem[] {
        return this.$store.state.tagList;
    }

    initRecord(): RecordItem {
        return {tag: {name: 'food', value: '餐饮'}, type: '-', note: '', amount: 0};
    }

    cancel() {
        this.$router.replace('/bill');
    }

    complete() {
        this.$store.commit('insertRecord', clone<RecordItem>(this.record));
        this.record = this.initRecord();
        this.$router.replace('/bill');
    }

    @Watch('record.type')
    onTypeChange(type: string) {
        if (type === '+') {
            this.record.tag = {name: 'salary', value: '工资'};
        } else if (type === '-') {
            this.record.tag = {name: 'food', value: '餐饮'};
        }
    }
}
